/* Custom-element lifecycle also covers Shopify Theme Editor section reloads. */
if (!customElements.get('lean-variant-grid')) {
  customElements.define('lean-variant-grid', class extends HTMLElement {
    connectedCallback() {
      this.touchMedia = matchMedia('(hover: none), (pointer: coarse)');
      this.motionMedia = matchMedia('(prefers-reduced-motion: reduce)');
      this.updateBurst = () => {
        this.observer?.disconnect();
        this.removeAttribute('data-burst-scroll');
        if (!this.touchMedia.matches || this.motionMedia.matches || !('IntersectionObserver' in window)) return;

        const images = this.querySelectorAll('.lean-variant-card__image-link:not([data-burst-revealed])');
        // Reveal when the image top reaches 55% of the viewport height.
        // Pixel margins avoid IntersectionObserver's width-based percentage margins.
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.setAttribute('data-burst-revealed', '');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: 0, rootMargin: `0px 0px -${Math.round(window.innerHeight * .45)}px 0px` });
        this.setAttribute('data-burst-scroll', '');
        images.forEach(image => {
          if (image.querySelector('.lean-flavor-burst')) this.observer.observe(image);
        });
      };
      this.touchMedia.addEventListener('change', this.updateBurst);
      this.motionMedia.addEventListener('change', this.updateBurst);
      this.resizeBurst = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.updateBurst, 150);
      };
      window.addEventListener('resize', this.resizeBurst);
      this.updateBurst();
    }

    disconnectedCallback() {
      clearTimeout(this.resizeTimer);
      window.removeEventListener('resize', this.resizeBurst);
      this.observer?.disconnect();
      this.touchMedia.removeEventListener('change', this.updateBurst);
      this.motionMedia.removeEventListener('change', this.updateBurst);
    }
  });
}
